// AccordionItem.jsx (Simplified Example)
import React from 'react';
import styles from './AccordionItem.module.css'; // Create this CSS module

const AccordionItem = ({ title, children, isOpen, onToggle }) => (
  <div className={styles.accordionItem}>
    <button className={styles.accordionHeader} onClick={onToggle} aria-expanded={isOpen}>
      {title}
      <span className={styles.accordionIcon}>{isOpen ? '-' : '+'}</span>
    </button>
    {isOpen && <div className={styles.accordionPanel}>{children}</div>}
  </div>
);
export default AccordionItem;